module.exports = __webpack_public_path__ + "static/media/logout.15552329.svg";